function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { DateTime } from 'luxon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera } from '@fortawesome/free-solid-svg-icons';
import { FixedSizeList as List } from 'react-window';
import Swipeout from 'rc-swipeout';
import Carousel, { Modal, ModalGateway } from 'react-images';
import Photo from '../../../../model/Photo';
import PhotoPanel from './PhotoPanel';
import View from './View';
import './PhotosPanel.css';

var PhotosPanel = /*#__PURE__*/function (_React$Component) {
  _inherits(PhotosPanel, _React$Component);

  function PhotosPanel(props) {
    var _this;

    _classCallCheck(this, PhotosPanel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PhotosPanel).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "toggleModal", function (photoId) {
      var parent = _this.props.parent;
      var currentImage = 0;

      if (photoId) {
        currentImage = parent.photos.map(function (photo) {
          return photo.id;
        }).indexOf(photoId);
      }

      _this.setState(function (state) {
        return {
          modalIsOpen: !state.modalIsOpen,
          currentImage: currentImage
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addPhoto", function () {
      var _this$props = _this.props,
          updateLogBookEntry = _this$props.updateLogBookEntry,
          parent = _this$props.parent,
          storage = _this$props.storage;
      window.plugins.actionsheet.show({
        androidTheme: window.plugins.actionsheet.ANDROID_THEMES.THEME_DEVICE_DEFAULT_DARK,
        // title: 'What do you want with this image?',
        // subtitle: 'Choose wisely, my friend',
        buttonLabels: ['Camera', 'Photo Library'],
        androidEnableCancelButton: true,
        addCancelButtonWithLabel: 'Cancel'
      }, function (buttonIndex) {
        navigator.camera.getPicture(function (imageData) {
          var photo = new Photo({
            imageData: imageData,
            parent: parent.id
          });
          photo.save(storage).then(function () {
            parent.photos.unshift(photo);
            updateLogBookEntry();
          }, function (error) {
            return console.error(error);
          });
        }, function (error) {
          console.error(error);
        }, {
          sourceType: buttonIndex === 1 ? Camera.PictureSourceType.CAMERA : Camera.PictureSourceType.PHOTOLIBRARY,
          quality: 90,
          correctOrientation: true,
          destinationType: Camera.DestinationType.DATA_URL
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderItem", function (_ref) {
      var index = _ref.index,
          key = _ref.key,
          style = _ref.style;

      var _assertThisInitialize = _assertThisInitialized(_this),
          addPhoto = _assertThisInitialize.addPhoto,
          deletePhoto = _assertThisInitialize.deletePhoto,
          toggleModal = _assertThisInitialize.toggleModal;

      var _this$props2 = _this.props,
          parent = _this$props2.parent,
          updateLogBookEntry = _this$props2.updateLogBookEntry,
          storage = _this$props2.storage;

      if (index === parent.photos.length) {
        return React.createElement("div", {
          className: "photo-container",
          key: 'new-photo',
          style: style
        }, React.createElement("div", {
          className: "photo new-photo ripple",
          onClick: addPhoto
        }, React.createElement(FontAwesomeIcon, {
          icon: faCamera
        })));
      } else {
        var photo = parent.photos[index];
        return React.createElement(PhotoPanel, {
          key: photo.id,
          style: style,
          updateLogBookEntry: updateLogBookEntry,
          parent: parent,
          photo: photo,
          storage: storage,
          toggleModal: toggleModal
        });
      }
    });

    _this.state = {
      currentImage: 0,
      modalIsOpen: false
    };
    return _this;
  }

  _createClass(PhotosPanel, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          currentImage = _this$state.currentImage,
          modalIsOpen = _this$state.modalIsOpen;
      var renderItem = this.renderItem,
          toggleModal = this.toggleModal;
      var _this$props3 = this.props,
          width = _this$props3.width,
          parent = _this$props3.parent,
          storage = _this$props3.storage;
      var views = modalIsOpen ? parent.photos.map(function (photo) {
        return {
          id: photo.id,
          photo: photo,
          storage: storage,
          toggleModal: toggleModal
        };
      }) : null;
      return React.createElement("div", {
        className: "photos-panel"
      }, React.createElement(ModalGateway, null, modalIsOpen ? React.createElement(Modal, {
        allowFullscreen: false,
        onClose: toggleModal
      }, React.createElement(Carousel, {
        interactionIsIdle: false,
        components: {
          Footer: null,
          View: View
        },
        frameProps: {
          autoSize: 'height'
        },
        currentImage: currentImage,
        views: views
      })) : null), React.createElement(List, {
        className: "photos",
        height: 75,
        itemSize: 110,
        itemCount: parent.photos.length + 1,
        layout: "horizontal",
        width: width - 20
      }, renderItem));
    }
  }]);

  return PhotosPanel;
}(React.Component);

export default PhotosPanel;